export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/credit-card-refresh.91aed4bf.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};